import { type ReactNode, useEffect, useState } from 'react';

type Props = {
  children: ReactNode;
  fallBack?: ReactNode;
};

const ClientOnly = ({ children, fallBack }: Props) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  return <>{!hasMounted ? fallBack || null : children}</>;
};

export default ClientOnly;
